<template>
    <v-layout row wrap>
        <v-flex xs9 class="mb-2 subheading blue--text">
            Options
        </v-flex>
        <v-flex xs3 class="text-xs-right">
            <v-icon @click="addRow" small>fas fa-plus-circle</v-icon>
        </v-flex>
        <v-flex xs5 class="pa-2 subheading body-2 primary white--text text-xs-center">
            Data Value
        </v-flex>
        <v-flex xs7 class="text-xs-center  subheading body-2 ">
            <v-layout row wrap>
                <v-flex xs11 class="pa-2 primary white--text ">
            Display Value
            </v-flex>
            </v-layout>
        </v-flex>
        
        <template v-for="(option,index) in options">
            <v-flex xs5>
                <v-text-field 
                    v-model="option.dataValue"
                    label=""                    
                    solo
                    class="pa-0 ma-0"
                    height="26px"
                    single-line
                    @change="optionChanged"
                    hide-details
                />
            </v-flex>
            <v-flex xs7>
                <v-layout row wrap>
                    <v-flex xs11>
                <v-text-field 
                    v-model="option.displayValue"
                    label=""
                    solo
                    height="26px"
                    single-line
                     @change="optionChanged"
                    hide-details
                />
                </v-flex>
                <v-flex xs1 class="pt-2">
                    &nbsp;
               <v-icon @click="deleteRow(index)" small>fas fa-trash</v-icon>
               </v-flex>
               </v-layout>
            </v-flex>
        </template>
    </v-layout>
</template>
<script>
export default {
    props:["optionValues"],
    data() {
        return {
            options:[
                {"dataValue":"",displayValue:""}
            ]
        }
    },
    watch:{
        optionValues() {   
            this.options = this.optionValues
        }
    },
    created:function() {
    },
    mounted:function() {
           this.options = this.optionValues
    },
    methods: {
        addRow() {
            this.options.push({
                "dataValue":"",displayValue:""
            })
        },
        deleteRow($index) {
            this.options.splice($index,1)
        },
        optionChanged() {
            this.$emit('optionChanged',this.options)
        }
    }
}
</script>